export default __webpack_public_path__ + "static/media/shoeee.e1ecf99b.jpg";